export default __webpack_public_path__ + "static/media/chat-bubble-dark.6763ff72.svg";